import type { ServiceCatalog } from '@/entities/service-catalog';

// Returns '' when nothing qualifies, which intentionally fails the form's required-service check.
export function getDefaultServiceCode(catalog: ServiceCatalog, serviceCodes: string[]): string {
    const codesInCatalog = new Set(catalog.services.map((service) => service.code));
    const firstKnownCode = serviceCodes.find((code) => codesInCatalog.has(code));
    if (firstKnownCode) return firstKnownCode;

    const defaultService = catalog.services.find((service) => service.isDefault);
    return defaultService?.code ?? '';
}
